<template>
  <v-btn-toggle v-model="toggle_exclusive" mandatory style="width: 100%">
    <v-btn
      large
      v-for="item in items"
      :key="item.status"
      @click="setGroupExport(item.value)"
      style="flex: 1"
    >
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "components-common-filters-group-status",

  props: ["hideExport", "hideWeb"],

  data: () => ({
    items: [
      // { text: "Site", value: "" },
      // { text: "CSV", value: "csv" },
      // { text: "XLSX", value: "xlsx" },
    ],
    toggle_exclusive: 0,
  }),

  computed: {
    exportState() {
      return this.$store.state.filters.groupExport.value;
    },
    thesePathsHideXLSX() {
      const paths = [
        "/reports/reportUsers",
        "/reports/reportSportBets",
        "/reports/reportDeposits",
        "/reports/reportWithdrawals",
        "/reports/reportCasinoBets"
      ];
      let hide = false;
      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });
      return hide;      
    }
  },

  mounted() {
    this.changeItems();
  },

  watch: {
    $route(val) {
      val && this.changeItems();
    },
    // Esse tratamento é necessário para views que usam
    // paginação server-side e exportDoc
    exportState(value) {
      if (value == "") this.toggle_exclusive = 0;
    }
  },

  methods: {
    setGroupExport(value) {
      this.$store.commit("setGroupExport", value);
    },
    changeItems() {
      this.toggle_exclusive = 0;

      if (this.hideExport) {
        this.items = [{ text: "Web", value: "" }];
        return;
      }

      if (
        this.$route.name === "PlayersOnlineInactives" ||
        this.$route.name === "CollaboratorPlayersOnlineInactives" ||
        this.hideWeb
      ) {
        this.items = [
          { text: "XLSX", value: "xlsx" },
          { text: "CSV", value: "csv" },
        ];

        this.$store.commit("setGroupExport", "xlsx");
      } else if (
        this.$route.name === "AdministratorSystemSearchLogs" ||
        this.$route.name === "ListAdhesions" ||
        this.$route.name === "CollaboratorListAdhesions"
      ) {
        this.$store.commit("setGroupExport", "xlsx");
        this.items = [
          { text: "XLSX", value: "xlsx" },
          { text: "CSV", value: "csv" },
        ];
      } else if (this.thesePathsHideXLSX) {
        this.$store.commit("setGroupExport", "");
        this.items = [
          { text: "Web", value: "" },
          { text: "CSV", value: "csv" },
        ];
      } else {
        this.$store.commit("setGroupExport", "");
        this.items = [
          { text: "Web", value: "" },
          { text: "XLSX", value: "xlsx" },
          { text: "CSV", value: "csv" },
        ];
      }
    },
  },
};
</script>
